<form [formGroup]="form" (ngSubmit)="onSubmit()" class="detail-form">
  <div class="form-horizontal">
    <div class="form-group">
      <div class="row">
        @if (isEditForm()) {
          <div class="logo">
            <img [src]="currentUser.avatar" alt="Avatar" class="img-responsive" />
          </div>
        }
        <div class="form-detail">
          @if (isEditForm()) {
            <div class="user-info">
              <div class="info">
                <p class="date">{{ assessment?.created_at }}</p>
                <p>{{ currentUser.name }}さん</p>
              </div>
            </div>
          }
          <textarea
            #textArea
            [appPlaceholder]="'活動記録を読んで、どのようなことを思いましたか？考えましたか？'"
            formControlName="content"
            appAutoExpand
          >
          </textarea>
          @if (formErrors['content']) {
            <div class="spen-mod-error-content">
              {{ formErrors['content'].join(' ') }}
            </div>
          }
          @if (assessment?.is_reviewing && !!assessment?.review_reason) {
            <p class="review-title">見直し理由</p>
            <div class="review-reason preserve-line-break">{{ assessment.review_reason }}</div>
          }
        </div>
        <div class="buttons">
          <button type="submit" class="spen-mod-btn is-primary" [disabled]="isSubmitting || isContentInvalid()">
            {{ isEditForm() ? '編集を完了する' : 'コメントする' }}
          </button>
          @if (isEditForm()) {
            <button type="button" class="spen-mod-btn" (click)="cancelEdit()">キャンセル</button>
          }
          @if (isEditForm()) {
            <div class="delete-comment">
              <span class="spen-util-link" (click)="deleteAssessment()"><i class="fa fa-trash-o"></i>削除する</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</form>
